export const GET_SUBSCRIBER = "GET_SUBSCRIBER";
export const GET_SUBSCHOICE = "GET_SUBSCHOICE";
// export const TOGGLE_CHECKBOX = "TOGGLE_CHECKBOX";






export const EDIT_SUBSCRIPTIONS_REQUEST = "EDIT_SUBSCRIPTIONS_REQUEST";
export const EDIT_SUBSCRIPTIONS_SUCCESS = "EDIT_SUBSCRIPTIONS_SUCCESS";
export const EDIT_SUBSCRIPTIONS_FAIL = "EDIT_SUBSCRIPTIONS_FAIL";
export const GET_SUBSCRIPTION_CHECKBOX = "GET_SUBSCRIPTION_CHECKBOX"